import * as React from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Tooltip from "@mui/material/Tooltip";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

function Row(props) {
  const { row, index } = props;
  const [open, setOpen] = React.useState(false);
  const [isCopy, setIsCopy] = useState(false);

  function saveToClipboard(url) {
    navigator.clipboard.writeText(url);
    setIsCopy(true);
  }
  function handleHover() {
    setIsCopy(false);
  }

  function handleDelete(fileId, fileName, index) {
    props.deleteTableRow(fileId, fileName, index);
  }
  function handleEdit(info) {
    props.editTableRow(info);
  }

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell className="tableCell">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell
          className="tableCell"
          align="left"
          component="th"
          scope="row"
        >
          {row.fileName}
        </TableCell>
        <TableCell className="tableCell" align="center">
          <Tooltip
            className="addButton"
            fontSize="large"
            title={isCopy ? "Copied" : "Copy link"}
          >
            <ContentCopyIcon
              onMouseLeave={handleHover}
              onClick={() => saveToClipboard(row.url)}
            />
          </Tooltip>
        </TableCell>
        <TableCell className="tableCell" align="center">
          <Tooltip
            className="addButton"
            style={{ marginRight: "30px" }}
            fontSize="large"
            title="Edit"
          >
            <EditIcon onClick={() => handleEdit(row)} />
          </Tooltip>
        </TableCell>
        <TableCell className="tableCell" align="center">
          <Tooltip className="removeButton" fontSize="large" title="Delete">
            <DeleteIcon
              onClick={() => handleDelete(row.fileId, row.fileName, index)}
            />
          </Tooltip>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{
            paddingBottom: 0,
            paddingTop: 0,
            backgroundColor: "#fcfcfc",
          }}
          colSpan={6}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1, marginBottom: 0 }}>
              <Typography
                variant="h5"
                fontWeight={600}
                gutterBottom
                component="div"
              >
                Configuration Details
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell className="collapse-table-head">Role</TableCell>
                    <TableCell className="collapse-table-head">
                      Blockchain Network
                    </TableCell>
                    <TableCell className="collapse-table-head" align="center">
                      Token Standard
                    </TableCell>
                    <TableCell className="collapse-table-head" align="center">
                      Contract Address
                    </TableCell>
                    <TableCell className="collapse-table-head" align="center">
                      Token ID
                    </TableCell>
                    <TableCell className="collapse-table-head" align="center">
                      Min. NFT Required
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.tokenGatingDetails.map((details) => (
                    <TableRow key={details.permission}>
                      <TableCell
                        className="collapse-table-cell"
                        component="th"
                        scope="row"
                      >
                        {details.permission}
                      </TableCell>
                      <TableCell className="collapse-table-cell">
                        {details.blockchainNetwork}
                      </TableCell>
                      <TableCell className="collapse-table-cell" align="center">
                        {details.tokenStandard}
                      </TableCell>
                      <TableCell className="collapse-table-cell" align="center">
                        {details.contractAddress}
                      </TableCell>
                      <TableCell className="collapse-table-cell" align="center">
                        {details.tokenId ? details.tokenId : "-"}
                      </TableCell>
                      <TableCell className="collapse-table-cell" align="center">
                        {details.nftRequired ? details.nftRequired : "-"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default Row;
